var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5333 2.00195H9.46667C4.70044 2.00195 2 4.7024 2 9.46862V22.5353C2 27.2891 4.688 30.002 9.46667 30.002H22.5333C27.2996 30.002 30 27.2891 30 22.5353V9.46862C30 4.7024 27.2996 2.00195 22.5333 2.00195Z",
    fill: "url(#paint0_linear_2059_51075)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6471 16.994H17.0478V20.5621C17.0478 21.1366 16.578 21.6023 15.9984 21.6023C15.4189 21.6023 14.9491 21.1366 14.9491 20.5621V16.994H11.3498C10.8092 16.9385 10.3984 16.4869 10.3984 15.9482C10.3984 15.4094 10.8092 14.9579 11.3498 14.9024H14.9378V11.3455C14.9938 10.8096 15.4493 10.4023 15.9928 10.4023C16.5363 10.4023 16.9918 10.8096 17.0478 11.3455V14.9024H20.6471C21.1876 14.9579 21.5984 15.4094 21.5984 15.9482C21.5984 16.4869 21.1876 16.9385 20.6471 16.994Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2059_51075",
    x1: 2,
    y1: 2.00195,
    x2: 2,
    y2: 30.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/new_order.d6e5004715f463c68dea5d4c064ec961.svg";
export { ForwardRef as ReactComponent };